import { Injectable } from '@angular/core';
import { Meta } from '@angular/platform-browser';
import { CanActivate } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SeoGuard implements CanActivate {
    constructor(private readonly meta: Meta) { }

    canActivate(): boolean {
        this.meta.updateTag({ name: 'robots', content: 'noindex, nofollow' });
        return true;
    }
}
